// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__jIEcYrF3lr{max-width:600px;width:100%}`, "",{"version":3,"sources":["webpack://./src/assets/components/shared/companyModal/style/companyModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,eAAA,CACA,UAAA","sourcesContent":[".modal {\n  max-width: 600px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__jIEcYrF3lr`
};
export default ___CSS_LOADER_EXPORT___;
